import API from '@/services/api';
import Token from '@/services/token';

// Actions
export const LOGIN = 'authLogin';
export const FORGOT_PASSWORD = 'authForgotPassword';
export const RESET_PASSWORD = 'authResetPassword';
export const SET_PASSWORD = 'authSetPassword';
export const CHECK_AUTH = 'authCheck';
export const LOGOUT = 'authLogout';

// Current user
export const FETCH_CURRENT_USER = 'fetchCurrentUser';
export const UPDATE_CURRENT_USER = 'updateCurrentUser';

// Mutations
export const PURGE_AUTH = 'authPurgeAuth';
export const SET_AUTH = 'authSetUser';
export const SET_TOKEN = 'authSetToken';

const state = {
    user: {
        roles: []
    },
    isAuthenticated: !!Token.getToken()
};

const getters = {
    currentUser(state) {
        return state.user
    },
    isAuthenticated(state) {
        return state.isAuthenticated
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise((resolve, reject) => {
            API
                .post('auth/login', credentials)
                .then(({data}) => {
                    context.commit(SET_TOKEN, data.accessToken);
                    context.commit(SET_AUTH, data);

                    API.setHeader();

                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                })
        })
    },
    [FORGOT_PASSWORD](context, email) {
        return new Promise((resolve, reject) => {
            API
                .post('auth/password/forgotten', email)
                .then(() => {
                    resolve();
                })
                .catch(({response}) => {
                    reject(response.data);
                })
        })
    },
    [RESET_PASSWORD](context, data) {
        return new Promise((resolve, reject) => {
            API
                .post('auth/password/reset', data)
                .then(() => {
                    resolve();
                })
                .catch(({response}) => {
                    reject(response.data);
                })
        })
    },
    [SET_PASSWORD](context, data) {
        return new Promise((resolve, reject) => {
            API
                .post('auth/set-password', data)
                .then(() => {
                    resolve();
                })
                .catch(({response}) => {
                    reject(response.data);
                })
        })
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH)
    },
    [CHECK_AUTH](context) {
        API.setHeader();

        if (Token.getToken()) {
            API
                .get('auth/user')
                .then(({data}) => {
                    context.commit(SET_AUTH, data);
                })
                .catch(() => {
                    context.commit(PURGE_AUTH);
                })
        } else {
            context.commit(PURGE_AUTH)
        }
    },
    [FETCH_CURRENT_USER]() {
        return new Promise((resolve, reject) => {
            API
                .query('auth/user')
                .then((response) => {
                    resolve(response.data);
                })
                .catch((response) => {
                    reject(response);
                });
        });
    },
    [UPDATE_CURRENT_USER](context, changes) {
        return new Promise((resolve, reject) => {
            API
                .put('auth/user', changes)
                .then((response) => {
                    context.commit(SET_AUTH, response.data);
                    resolve(response.data);
                })
                .catch(({response}) => {
                    reject(response.data);
                });
        });
    }
};

const mutations = {
    [SET_TOKEN](state, token) {
        Token.saveToken(token);
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.user = user;
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};

        Token.destroyToken();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}